/* == theme */
import { UseCssVarRef } from "./common/composition/use-css-var";

const cssVars = {
  "--dropdown": {
    light: "white",
    dark: "#304053",
  },
  "--main-navbar": {
    light: "#293748",
    dark: "#202b38",
  },
  "--main-navbar-hover": {
    light: "#405064",
    dark: "#405064",
  },
  "--primary": {
    light: "#2196f3",
    dark: "#45a3f0",
  },
  "--dark": {
    light: "#293748",
    dark: "#f5f7fb",
  },
  "--dark-hover": {
    light: "#405064",
    dark: "#e8edf7",
  },
  "--darkest": {
    light: "#0f1a26",
    dark: "#ffffff",
  },
  "--light": {
    light: "#f5f7fb",
    dark: "#293748",
  },
  "--lightest": {
    light: "#ffffff",
    dark: "#1d2c3d",
  },
  "--navbar": {
    light: "#BDD8EB",
    dark: "#202b38",
  },
  "--navbar-tab": {
    light: "#A8CCE5",
    dark: "#3a596f",
  },
  "--navbar-tab-selected": {
    light: "#f5f7fb",
    dark: "#45a3f0",
  },
  "--main-1": {
    light: "#164174",
    dark: "#63a3dd",
  },
  "--main-2": {
    light: "#abc2e2",
    dark: "#5274a3",
  },
  "--main-3": {
    light: "#e2ebf8",
    dark: "#3c516d",
  },
  "--container-1": {
    light: "#eef2f6",
    dark: "#3c516d",
  },
  "--main-3-hover": {
    light: "#bfd0e8",
    dark: "#7d8ca1",
  },
  "--main-4": {
    light: "#f5f7fb",
    dark: "#21364b",
  },
  "--main-4-hover": {
    light: "#e8edf7",
    dark: "#25394d",
  },
  "--main-5": {
    light: "#a8cce5",
    dark: "#384e5e",
  },
  "--main-6": {
    light: "#ceddf2",
    dark: "#506580",
  },
  "--main-6-hover": {
    light: "#c3d1e5",
    dark: "#556b87",
  },
  "--level-h-light": {
    light: "#FFD4D4",
    dark: "#ffd4d4",
  },
  "--level-m-light": {
    light: "#FFEDD4",
    dark: "#ffc107",
  },
  "--level-m-bold": {
    light: "#F4B714",
    dark: "#F4B714",
  },
  "--level-l-light": {
    light: "#D0F2D2",
    dark: "#D0F2D2",
  },
  "--gray-100": {
    light: "#f7fafc",
    dark: "#1a202c",
  },
  "--gray-150": {
    light: "#eeeeee",
    dark: "#2d3748",
  },
  "--gray-200": {
    light: "#edf2f7",
    dark: "#4a5568",
  },
  "--gray-300": {
    light: "#e2e8f0",
    dark: "#718096",
  },
  "--gray-400": {
    light: "#cbd5e0",
    dark: "#a0aec0",
  },
  "--gray-500": {
    light: "#a0aec0",
    dark: "#cbd5e0",
  },
  "--gray-600": {
    light: "#718096",
    dark: "#e2e8f0",
  },
  "--gray-700": {
    light: "#4a5568",
    dark: "#edf2f7",
  },
  "--gray-800": {
    light: "#2d3748",
    dark: "#eeeeee",
  },
  "--gray-900": {
    light: "#1a202c",
    dark: "#f7fafc",
  },
};

export const ThemeColors = [
  "main-1",
  "main-2",
  "main-3",
  "main-4",
  "main-5",
  "main-6",
  "level-l",
  "level-m",
  "level-h",
];

// @ts-ignore
window.changeTheme = (theme: "dark" | "light" = "light") => {
  Object.entries(cssVars).forEach(([varName, colors]) => {
    document.documentElement.style.setProperty(varName, colors[theme]);
    const var_ref = UseCssVarRef(varName);
    var_ref.value = colors[theme];
  });
};

export const Colors: Record<string, string> = {
  onedrive: "#3da3e2",
  exchange_365: "#1b81b4", //"#26a8ea",
  ms_teams: "#6264A7",
  sharepoint: "#337f83",
  gmail: "#EA4335",
  gdrive: "#4285F4",
};
